import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { ProjectMenu } from '../components/ProjectMenu';
import { DispatchBrain } from '../components/DispatchBrain';
import { StackSection } from '../components/StackSection';
import { Faq } from '../components/Faq';
import { NextStepPanel } from '../components/NextStepPanel';
import { usePageTitle } from '../hooks/usePageTitle';
export function Services() {
  usePageTitle('Services | Viridia Analytics');
  return <>
      <PageHeader eyebrow="Services" title="Four ways in. One system underneath." data-id="element-462" data-mp="3t9nwknr9tzz3" />
      <ProjectMenu data-id="element-463" data-mp="b3ssrjceva46" />
      <DispatchBrain eyebrow="Inside the system" data-id="element-464" data-mp="b4avmytkwml2" />
      <StackSection data-id="element-465" data-mp="b1orza9t6r84" />
      <Faq data-id="element-466" data-mp="657sjjx5sqfq" />
      <NextStepPanel title="Start with the free part." buttonLabel="Book your free Response Audit" to="/book" data-id="element-467" data-mp="64galbwhir7x" />
    </>;
}